import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

const GoTop = (props) => {
    return (
        <>
        <button className="goTop sm:hidden">
            <Link to="/#top" className="font-medium text-black flex items-center transition duration-500 ease-in-out" aria-label="ACM-Site">
                <img className="mx-auto w-8 h-8 goTop__text" src={require('../images/chevron.svg').default} alt="move_up_alt"/>
            </Link>
        </button>
        </>
    );
};
export default GoTop;